"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _inline_svg = _interopRequireDefault(require("./inline_svg.proptypes"));

var DisableCheckIcon = function DisableCheckIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M10.344 16.9625L18.1875 9.11905L16.9582 7.88967L10.344 14.5038L7.01905 11.1788L5.78967 12.4082L10.344 16.9625ZM12.0019 23.0832C10.4689 23.0832 9.02795 22.7923 7.67909 22.2105C6.33023 21.6287 5.15695 20.8392 4.15925 19.8419C3.16156 18.8446 2.37163 17.6718 1.78946 16.3235C1.20749 14.9752 0.916504 13.5347 0.916504 12.0019C0.916504 10.4689 1.20739 9.02795 1.78917 7.67909C2.37095 6.33023 3.16049 5.15695 4.1578 4.15925C5.1551 3.16156 6.32789 2.37163 7.67617 1.78946C9.02445 1.20749 10.465 0.916504 11.9978 0.916504C13.5308 0.916504 14.9717 1.20739 16.3206 1.78917C17.6695 2.37095 18.8427 3.16049 19.8404 4.1578C20.8381 5.1551 21.628 6.32789 22.2102 7.67617C22.7922 9.02445 23.0832 10.465 23.0832 11.9978C23.0832 13.5308 22.7923 14.9717 22.2105 16.3206C21.6287 17.6695 20.8392 18.8427 19.8419 19.8404C18.8446 20.8381 17.6718 21.628 16.3235 22.2102C14.9752 22.7922 13.5347 23.0832 12.0019 23.0832Z",
    fill: "#D0D0D2"
  }));
};

DisableCheckIcon.propTypes = _inline_svg.default.propTypes;
DisableCheckIcon.defaultProps = _inline_svg.default.defaultProps;
var _default = DisableCheckIcon;
exports.default = _default;